export * from './lib/medrecord-storage.module';
export * from './lib/services/storage.service';
export * from './lib/storage.injection-token';
